import { render, staticRenderFns } from "./v-leftBlock.vue?vue&type=template&id=539a65e4&"
import script from "./v-leftBlock.vue?vue&type=script&lang=js&"
export * from "./v-leftBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports